<template>
  <div class="production_wrap">
    <div class="production_img">
      <div class="img_tit">{{ $t('lcaPage.title') }}</div>
    </div>

    <!-- 近期课程列表 -->
    <div class="course_list_wrap">
      <div class="course_list_title_row">
        <h2 class="course_list_title">
          {{ $t('lcaPage.recentCourses') }}
          <span class="course_list_tip">{{ $t('lcaPage.recentTip') }}</span>
        </h2>
      </div>

      <el-table
        :data="courses"
        border
        stripe
        style="width: 100%"
        class="course-table"
      >
        <el-table-column
          label="#"
          type="index"
          width="60"
          align="center"
        />
        <el-table-column
          prop="category"
          :label="$t('lcaPage.courseCategories')"
          width="120"
          :formatter="(row) => $t(row.category)"
        />
        <el-table-column
          prop="subCategory"
          :label="$t('lcaPage.courseSubcategory')"
          width="140"
          :formatter="(row) => $t(row.subCategory)"
        />
        <el-table-column
          prop="name"
          :label="$t('lcaPage.seriesCourseName')"
          min-width="200"
        />
        <el-table-column
          prop="desc"
          :label="$t('lcaPage.courseDesc')"
          min-width="300"
        >
          <template #default="{ row }">
            <div class="course-desc">{{ row.desc }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <CallMe />
    <MobileCallme />
  </div>
</template>



<script>
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'

export default {
  components: {
    CallMe,
    MobileCallme,
  },
  data() {
    return {
    }
  },
  computed: {
    courses() {
      const messages = this.$i18n.getLocaleMessage(this.$i18n.locale)
      return messages.lcaPage?.courseList || []
    }
  },
  methods: {
    toSign(){
      this.$message.warning('当前课程暂未开放报名');
    },
  }
}
</script>

<style lang="scss" scoped>
.production_wrap {
  width: 100%;

  .production_img {
    width: 100%;
    height: 700px;
    background: url('../../assets/img/hly/training-bg3.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;

    .img_tit {
      font-size: 60px;
      font-weight: bold;
    }

    @media screen and (max-width: 768px) {
      height: 50vw;

      .img_tit {
        font-size: 1.4rem;
        padding: 0 10px;
        text-align: center;
      }
    }
  }

  .course_list_wrap {
    max-width: 1400px;
    margin: 40px auto 60px;
    padding: 0 20px;

    @media screen and (max-width: 768px) {
      padding: 0 10px;
      max-width: 1200px;
    }
  }

  .course_list_title_row {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 30px;

    .course_list_title {
      font-size: 38px;
      font-weight: bold;
      color: #333;
      display: inline-flex;
      align-items: center;

      .course_list_tip {
        font-size: 16px;
        color: #999;
        font-weight: normal;
        margin-left: 16px;
      }

      @media screen and (max-width: 768px) {
        font-size: 1.8rem;
        flex-direction: column;
        align-items: flex-start;

        .course_list_tip {
          font-size: 0.95rem;
          margin-left: 0;
          margin-top: 6px;
        }
      }
    }
  }

  .course-table {
    font-size: 16px;
    overflow-x: auto;

    ::v-deep(.el-table__header th) {
      background-color: #f5f7fa;
      font-weight: bold;
      color: #333;
    }
  }

  .course-desc {
    white-space: pre-wrap;
    word-break: break-word;
    line-height: 1.6;
    font-size: 16px; /* 提高字体大小 */
    color: #333;

    @media screen and (max-width: 768px) {
      font-size: 14px; /* 移动端稍微小点 */
    }
  }

}
</style>

<style lang="scss">
/* 非 scoped 样式：移动端 + 笔记本屏幕字体适配 */

@media screen and (max-width: 768px) {
  .course-table {
    overflow-x: auto;
  }
  .course-table .el-table {
    width: max-content;
  }
  .course-table .el-table__header th {
    font-size: 14px !important;
    padding: 10px 8px;
  }
  .course-table .el-table__header th .cell {
    line-height: 1.6 !important;
  }
  .course-table .el-table__body td {
    font-size: 14px !important;
    padding: 10px 8px;
  }
  .course-table .el-table__body td .cell {
    font-size: 14px !important;
    line-height: 1.6;
    white-space: pre-wrap;
  }
  .course-table .el-table__body td:last-child .cell {
    font-size: 15px !important;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1440px) {
  .course-table .el-table__header th {
    font-size: 16px !important;
  }
  .course-table .el-table__header th .cell {
    line-height: 1.8 !important;
  }
  .course-table .el-table__body td {
    font-size: 16px !important;
  }
  .course-table .el-table__body td .cell {
    font-size: 16px !important;
    line-height: 1.8;
  }
  .course-table .el-table__body td:last-child .cell {
    font-size: 17px !important;
  }
}
</style>
